module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/eyecatch-problem-03-b564f8e5356e34da91eb3042287d8407.png";